import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="py-24 lg:py-32 bg-navy-800 relative" data-id="element-132">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-133">
        <FadeIn data-id="element-134">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-12 text-center leading-tight" data-id="element-135">
            Tu mente se ha convertido en un{' '}
            <span className="text-amber-500 italic" data-id="element-136">lugar agotador.</span>
          </h2>
        </FadeIn>

        <div className="space-y-8 text-lg sm:text-xl text-offwhite/90 leading-relaxed font-light" data-id="element-137">
          <FadeIn delay={0.1} data-id="element-138">
            <p data-id="element-139">
              No es el trabajo lo que te tiene drenado. Es el ruido. Es esa
              conversación que repasas por décima vez en tu cabeza. Es ese
              escenario catastrófico que "ensayas" por si pasa lo peor.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-140">
            <p data-id="element-141">
              Es la incapacidad de estar presente en una cena o en tu propia
              cama porque tu cerebro ha decidido encender una radio de ansiedad
              que no tiene botón de apagado.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-142">
            <div className="pl-6 border-l-2 border-amber-500 my-12 py-2" data-id="element-143">
              <p className="text-xl sm:text-2xl font-serif text-white italic" data-id="element-144">
                Intentar calmarse con la voluntad es el error más común. Es como
                intentar apagar un incendio de gasolina con un vaso de agua.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-145">
            <p data-id="element-146">
              La lógica no funciona cuando tu sistema nervioso está atrapado en
              un bucle biológico de alerta.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-147">
            <p className="text-2xl font-bold text-white text-center mt-16 pb-4 border-b border-steel-800" data-id="element-148">
              No necesitas "relajarte".
              <br data-id="element-149" />
              <span className="text-amber-500" data-id="element-150">
                Necesitas una intervención mecánica.
              </span>
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}